import * as React from 'react';
import classnames from 'classnames';

import { FlagStore } from '../../../flux/Flag/FlagStore';
import { Modal } from '../../../../components/Modal';
import { Container } from '../../../Container';
import { Button } from '../../../../components/Buttons';

const style = require('./OneButtonDialog.scss');

export interface OneButtonDialogProps
{
    visibilityStore: FlagStore;

    title: string;
    ok: () => void;
    okTitle: string;    
}
type Props = OneButtonDialogProps & { children?: React.ReactNode };

export const OneButtonDialog = (props: Props) =>
{
    const { title, ok, okTitle } = props;
    return (
        <Container stores={[props.visibilityStore]} render={() => (
            props.visibilityStore.isSet() &&
            <Modal>
                <div className={style.Dialog}>
                    <h3 className="text-center">{title}</h3>
                    {props.children}
                    <div className={classnames(style.ButtomToolbar, 'btn-toolbar pull-right')}>
                        <Button type="success" onClick={ok} autoFocus>{okTitle}</Button>
                    </div>
                </div>
            </Modal>                    
        )}/>
    );
}


// WEBPACK FOOTER //
// ./src/app/components/Dialogs/OneButtonDialog/OneButtonDialog.tsx